<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t("paymenttypeswisesalesreport") }}</div>
      <div class="mt-3 mb-0">
        <div class="row">
          <!-- SELECT DROPDOWN -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="getMunicipaltyReportsSelectedCinema ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :text="getMunicipaltyReportsSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
                :disabled="isRoleID"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    :placeholder="$tc('searchCinema')"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  @click="
                    onMunicipaltyReportDropDownHandler({
                      event: $event,
                      name: 'isCinema',
                      selectedItem: dropdownItem,
                      index: dropdownIndex
                    });
                    searchCinema = '';
                    onSearchCinema();
                    onSelectCinema(dropdownItem);
                  "
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <div class="col-lg-4 col-xl-2 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getMunicipaltyReportFromDate"
                  @click="
                    onMunicipaltyReportDropDownHandler({
                      event: null,
                      name: 'fromDate'
                    })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="
                    onMunicipaltyReportDropDownHandler({
                      event: $event,
                      name: 'fromDate'
                    })
                  "
                  :value="getMunicipaltyReportFromDate"
                  typeable
                ></Datepicker>
                <label :class="getMunicipaltyReportFromDate ? 'active' : ''">{{
                  $t("startdate")
                }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getMunicipaltyReportEndDate"
                  @click="
                    onMunicipaltyReportDropDownHandler({
                      event: null,
                      name: 'endDate'
                    })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="
                    onMunicipaltyReportDropDownHandler({
                      event: $event,
                      name: 'endDate'
                    })
                  "
                  :value="getMunicipaltyReportEndDate"
                  typeable
                ></Datepicker>
                <label :class="getMunicipaltyReportEndDate ? 'active' : ''">{{
                  $t("enddate")
                }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-4">
            <button @click="onFetchMunicipaltyReport" class="btn-blue-lg w-100">
              {{ $tc("getReport") }}
            </button>
          </div>

          <div
          v-if="getMunicipaltyReportData && getMunicipaltyReportData.length > 0"
          class="col-lg-4 col-xl-3 align-self-center mb-4 d-flex justify-content-end align-items-center"
        >
          <div>{{ $t("download") }} as:</div>
          <a
            v-if="getMunicipaltyReportsPDFFileName"
            :href="BASE_URL + getMunicipaltyReportsPDFFileName"
            target="_blank"
            download
            title="Download as PDF"
          >
            <img class="mx-1" src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>

          <a
            v-if="getMunicipaltyReportsExcelFileName"
            :href="BASE_URL + getMunicipaltyReportsExcelFileName"
            target="_blank"
            title="Download as Excel"
            download
          >
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div>


        </div>
      </div>
      <div class="swc-report">
        <table class="swc-report-table w-100" border="1">
          <thead class>
            <tr class="bg-lightgrey">
              <th>{{ $t("show") }} {{ $t("date") }}</th>
              <th>{{ $tc("payment", 1) }} {{ $tc("type", 1) }}</th>
              <th>{{ $tc("ticket", 1) }} {{ $t("rate") }}</th>
              <th>{{ $t("total") }} {{ $tc("ticket", 1) }} Sold</th>
              <th>{{ $t("grossAmount") }}</th>
              <th>{{ $t("discount") }}</th>
              <th>{{ $t("taxamount") }}</th>
            </tr>
          </thead>
          <tbody
            v-for="(showDates, showDateIndex) in getMunicipaltyReportData"
            :key="showDateIndex"
            class="sph-report"
          >
            <tr
              v-for="(transaction, transactionIndex) in showDates.transactions"
              :key="transactionIndex"
            >
              <td :rowspan="transaction.length">
                {{ showDates.t_show_date | dateparse }}
              </td>
              <td>{{ transaction.payment_mode }}</td>
              <td>{{ currFormat(transaction.ticket_rate) }}</td>
              <td>{{ transaction.total_tickets_sold }}</td>
              <td>{{ currFormat(transaction.gross_amount) }}</td>
              <td>{{ currFormat(transaction.offer_price) }}</td>
              <td>{{ currFormat(transaction.tax_amount) }}</td>
            </tr>
            <tr class="bg-lightgrey">
              <th colspan="3" style="text-align: center;">
                {{ $t("total") }} of {{ showDates.t_show_date | dateparse }}
              </th>
              <th>
                {{
                  showDates.transactions.reduce(
                    (acc, { total_tickets_sold }) => acc + total_tickets_sold,
                    0
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    showDates.transactions.reduce(
                      (acc, { gross_amount }) => acc + gross_amount,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    showDates.transactions.reduce(
                      (acc, { offer_price }) => acc + offer_price,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    showDates.transactions.reduce(
                      (acc, { tax_amount }) => acc + tax_amount,
                      0
                    )
                  )
                }}
              </th>
            </tr>
          </tbody>
          <tbody v-if="getMunicipaltyReportData.length === 0">
            <tr>
              <td colspan="7">
                <!-- <p class="h6 mb-0 text-center">{{$t("NoRecords")}}</p> -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
        <line-chart
          v-if="chartloaded"
          :chartdata="chartData"
          :options="getChartOptions"
        />
        <bar-chart
          v-if="chartloaded"
          :chartdata="chartData"
          :options="getChartOptions"
        />
        <!-- <pie-chart
          v-if="chartloaded"
          :chartdata="chartData"
          :options="getChartOptions"
        /> -->
       
      </div>
    </div>
  </div>
</template>
<script>
import MasterService from "@/services/MasterService";
import DatePicker from "vue2-datepicker";
import { mapState, mapGetters, mapActions } from "vuex";
import LineChart from "@/components/ChartComponents/LineChart.js";
import BarChart from "@/components/ChartComponents/BarChart.js";
import PieChart from "@/components/ChartComponents/PieChart.js";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: { DatePicker, LineChart, BarChart, PieChart, NoRecords },
  data() {
    return {
      Cinemas: [],
      isRoleID: true,
      CinemasCopy: [],
      searchCinema: ""
    };
  },
  computed: {
    chartData() {
      return {
        labels: this.getLabels,
        datasets: [
          {
            label: "Total Ticket Sold",
            backgroundColor: "#f87979",
            data: this.getdatasets
          }
        ]
      };
    },
    ...mapGetters([
      "getCinemasList",
      "getMunicipaltyReportsSelectedCinema",
      "getMunicipaltyReportFromDate",
      "getMunicipaltyReportEndDate",
      "getMunicipaltyReportData",
      "getChartOptions",
      "getLabels",
      "getdatasets",
      "chartloaded",
      // EXCEL
      "getMunicipaltyReportsExcelFileName",
      // PDF
      "getMunicipaltyReportsPDFFileName"
    ])
  },
  mounted() {
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.getCinemaList(cinemaId);
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.onMunicipaltyReportDropDownHandler({
        event: null,
        name: "isCinema",
        selectedItem: CinemaObj
      });
    }
    // this.fetchCinemasList({ cinemaId });
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
      if (CinemaObj) {
        this.onMunicipaltyReportDropDownHandler({
          event: null,
          name: "isCinema",
          selectedItem: CinemaObj
        });
      }
    }
  },
  methods: {
    onSelectCinema(cinema) {
      this.$store.dispatch("selectDropdownCinema", cinema);
    },
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getCinemaList: function(cine_id) {
      this.Cinemas = [];
      //  let payload = null
      //   cine_id == null ?  payload = {tableName : 'ms_cinemas',cine_is_active: "Y"} : payload = {tableName : 'ms_cinemas',cine_is_active: "Y" ,cine_id : cine_id }
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                // let cinema = {
                //   cine_name: x.cine_name,
                //   cine_id: x.cine_id
                // };

                // this.onSelectCinema(null,cinema);
                this.onMunicipaltyReportDropDownHandler({
                  name: "isCinema",
                  selectedItem: {
                    cine_name: x.cine_name,
                    cine_id: x.cine_id
                  }
                });
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    ...mapActions([
      //
      "fetchCinemasList",
      "onMunicipaltyReportDropDownHandler",
      "onFetchMunicipaltyReport"
    ])
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/municipalityReport.vue